import { useMsal } from '@azure/msal-react';
import { isLocal } from '@/lib/isLocal';

export function useGetAccessToken(): () => Promise<string | null> {
  if (isLocal()) {
    return () => Promise.resolve(null);
  }
  const { instance } = useMsal();

  return async (): Promise<string | null> => {
    const redirectStartPage = window.location.href;
    const {
      auth: {
        OIDCOptions: { defaultScopes: scopes },
      },
    } = instance.getConfiguration();

    try {
      const account = instance.getActiveAccount();
      const token = await instance.acquireTokenSilent({ scopes, account });

      return token.accessToken;
    } catch (
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      e: unknown
    ) {
      await instance.acquireTokenRedirect({
        scopes,
        redirectStartPage,
      });

      return null;
    }
  };
}
